module.exports = __webpack_public_path__ + "img/dot-dk.8ee95cde.svg";